import { additionalFieldsData } from '../../variables/additional-fields-data';

export const validateBic = (value) => {
  const maskedValue = additionalFieldsData.bic.maskFunction(value);
  if (maskedValue === value && maskedValue.includes('*')) {
    // if the value is already masked
    return true;
  }

  return additionalFieldsData.bic.regexp.test(value);
};
